import type { Dispatch } from "react";
import type { ScheduleDataStateAction } from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/ScheduleDataState.ts";
import useDefinedContextValue from "@/shared/custom-hook/useDefinedContextValue.ts";
import { ScheduleDataStateDispatchContext } from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/ScheduleDataStateProvider.tsx";

export default function useScheduleDataStateDispatch(): Dispatch<ScheduleDataStateAction> {
  return useDefinedContextValue(ScheduleDataStateDispatchContext);
}
